<template>
  <button
    v-if="hasTourForCurrent"
    id="app-tour-trigger"
    type="button"
    @click="start"
    class="relative p-2 rounded-full transition-colors"
    :class="showHint
      ? 'text-primary bg-primary/10 animate-pulse'
      : 'text-gray-400 hover:text-primary hover:bg-primary/10'"
    :title="showHint ? 'New! Take a guided tour of this page' : 'Take a guided tour'"
    :aria-label="showHint ? 'Start guided tour (new)' : 'Start guided tour'"
  >
    <i class="pi pi-question-circle text-lg" />
    <span
      v-if="showHint"
      class="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-primary rounded-full border-2 border-white"
    />
  </button>
</template>

<script setup lang="ts">
import { useAppTour } from '@/composables/tour/useAppTour';

const { hasTourForCurrent, showHint, start } = useAppTour();
</script>
